var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "edit-attachments-component" }, [
    _vm.collectAttachments.length
      ? _c("div", { staticClass: "label-text" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.collectAttachments.length) +
              " Attachment" +
              _vm._s(_vm.collectAttachments.length > 1 ? "s" : "") +
              "\n    "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "attachments-wrap" },
      [
        _vm._l(_vm.collectAttachments, function(item) {
          return _c("EditAttachItem", {
            key: item.$index,
            attrs: { item: item },
            on: {
              delete: function($event) {
                return _vm.handleRemoveAttach(item)
              }
            }
          })
        }),
        _vm._v(" "),
        _vm.loading ? _c("div", { staticClass: "spinner-border" }) : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }